import React from 'react'
import { Drawer, withStyles, List, ListItem, ListItemIcon, ListItemText, Avatar } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faPlus } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';

const styles = (theme) => ({
    drawerPaper: { marginTop: 70, background: '#f5f1f1', width: 262, boxShadow: 'none', borderRight: 'none', marginLeft: 70, },
    ListItemPadding: { paddingLeft: 17, paddingRight: 13 },
    ListAvatar: { background: '#1b5e20', color: '#fff', fontSize: 14, width: 30, height: 30 },
    ListIconContainer: { minWidth: 36 },
    ListTitle: { fontSize: 14 },
    ListSubmenuIconArrow: { minWidth: 19, marginLeft: 37 },
    SublistTitles: { fontSize: 13 },
    SublistContainerPadding: { paddingTop: 4, paddingBottom: 4 },
    DrawerModel: { position: 'inherit !important' },
    DialpadIconCss: { fontSize: 16 },
})

const LegalSubmenu = (props) => {
    const { classes, openState, closeSubNavigation } = props;

    return (
        <React.Fragment>
            <Drawer
                variant="temporary"
                anchor="left"
                open={openState}
                onClose={closeSubNavigation}
                classes={{ paperAnchorLeft: classes.drawerPaper }}
            >
                <List component="nav" disablePadding>
                    {/* Manage Normal Templates */}
                    <ListItem
                        button
                        classes={{ gutters: classes.ListItemPadding }}
                        component={NavLink}
                        to="/legals/create"
                        onClick={() => { closeSubNavigation() }}
                    >
                        <ListItemIcon classes={{ root: classes.ListIconContainer }}>
                            <Avatar classes={{ root: classes.ListAvatar }}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.ListTitle }} primary="Create" />
                    </ListItem>

                    <ListItem
                        button
                        classes={{ gutters: classes.ListItemPadding }}
                        component={NavLink}
                        to="/legals/list-all"
                        onClick={() => { closeSubNavigation() }}
                    >
                        <ListItemIcon classes={{ root: classes.ListIconContainer }}>
                            <Avatar classes={{ root: classes.ListAvatar }}>
                                <FontAwesomeIcon icon={faList} />
                            </Avatar>
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.ListTitle }} primary="All List " />
                    </ListItem>

                </List>
            </Drawer>
        </React.Fragment>
    )
}

export default withStyles(styles)(LegalSubmenu);
